module.exports = __webpack_public_path__ + "static/img/ER.8210b1d2.svg";